import { Component, ElementRef, Input, OnInit } from '@angular/core';

const LOADING_DEFAULT_MESSAGE = 'Veuillez patienter ...';

@Component({
  selector: 'frg-loading-modal',
  templateUrl: './loading-modal.fragment.html',
  styleUrls: [
    './loading-modal.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class LoadingModalFragment implements OnInit {
  @Input() id: string;
  @Input() public message = LOADING_DEFAULT_MESSAGE;

  private element: any;

  constructor(
    private el: ElementRef
  ) {
    this.element = el.nativeElement;
  }

  public reinitMessage(): void {
    this.message = LOADING_DEFAULT_MESSAGE;
  }

  public ngOnInit(): void { }
  // ensure id attribute exists
  //   if (!this.id) {
  //     console.error('modal must have an id');
  //     return;
  //   }

  //   // move element to bottom of page (just before </body>) so it can be displayed above everything else
  //   document.body.appendChild(this.element);

  //   // close modal on background click
  //   this.element.addEventListener('click', el => {
  //     if (el.target.className === 'jw-modal') {
  //       this.close();
  //     }
  //   });

  //   // add self (this modal instance) to the modal service so it's accessible from controllers
  //   this.modalService.add(this);
  // }

  // // remove self from modal service when component is destroyed
  // public ngOnDestroy(): void {
  //   this.modalService.remove(this.id);
  //   this.element.remove();
  // }

  // // open modal
  // public open(): void {
  //   this.element.style.display = 'block';
  //   document.body.classList.add('jw-modal-open');
  // }

  // // close modal
  // public close(): void {
  //   this.element.style.display = 'none';
  //   document.body.classList.remove('jw-modal-open');
  // }

}
